// extracted by mini-css-extract-plugin
module.exports = {"panel":"Collapse_panel__ZL4Q_"};